/**
 * Jun-2026 (User-Wunsch) — sperrt einen kompletten Einstellungs-Abschnitt in
 * einer Filiale, wenn der zugehörige Bereich vom Hauptsitz „org-weit" gesteuert
 * wird. Zeigt ein Hinweis-Banner und macht den Inhalt read-only (ausgegraut,
 * keine Interaktion). Serverseitig sind diese Bereiche zusätzlich hart gesperrt
 * (403). Greift nur für Filialen; für alle anderen wird der Inhalt unverändert
 * gerendert.
 */
import { Lock } from "lucide-react";
import { useLockedFields } from "../../hooks/useLockedFields";

function LockShell({ area, children, label, compact }) {
    return (
        <div className="relative" data-testid={`org-locked-${area}`}>
            <div className={`flex items-start gap-2 bg-amber-50 border border-amber-200 text-amber-900 rounded-sm px-4 ${compact ? "py-2 text-xs" : "py-3 text-sm"} mb-2`} data-testid={`org-locked-banner-${area}`}>
                <Lock className={`${compact ? "w-3.5 h-3.5" : "w-4 h-4"} mt-0.5 shrink-0`} />
                <span>
                    <strong>Vom Hauptsitz zentral vorgegeben.</strong>{" "}
                    {label ? `${label} ` : ""}kann in dieser Filiale nicht geändert werden.
                </span>
            </div>
            {/* Jul-2026 (User-Meldung „graue Schrift unlesbar"): weniger ausgrauen,
                dafür klarer Sperr-Rahmen — Inhalt bleibt lesbar. */}
            <div className="opacity-75 grayscale-[35%] pointer-events-none select-none rounded-sm ring-1 ring-gray-200" aria-disabled="true">
                {children}
            </div>
        </div>
    );
}

export default function OrgLockedSection({ area, children, label }) {
    const { isAreaLocked } = useLockedFields();
    if (!isAreaLocked(area)) return <>{children}</>;
    return <LockShell area={area} label={label}>{children}</LockShell>;
}

// Granular: sperrt einen Teilbereich (z. B. marketing.social), wenn der Hauptsitz
// ihn org-weit übernimmt (Bereich aktiv + Teilbereich nicht ausgenommen).
export function OrgLockedSubgroup({ area, subKey, children, label }) {
    const { isSubgroupLocked } = useLockedFields();
    if (!isSubgroupLocked(area, subKey)) return <>{children}</>;
    return <LockShell area={`${area}-${subKey}`} label={label} compact>{children}</LockShell>;
}
